import { type ReactNode, type ReactElement } from 'react';
import { Text } from '@mantine/core';

interface Props {
  align?: 'left' | 'center' | 'right';
  children?: ReactNode;
}

export const TextHeader = (props: Props): ReactElement => {
  const { children, align = 'left' } = props;
  return <Text className={`text-${align} whitespace-nowrap`}>{children}</Text>;
};
